import { render, staticRenderFns } from "./DashboardNavigation.vue?vue&type=template&id=8f4df2d2&scoped=true&"
import script from "./DashboardNavigation.vue?vue&type=script&lang=js&"
export * from "./DashboardNavigation.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNavigation.vue?vue&type=style&index=0&id=8f4df2d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4df2d2",
  null
  
)

export default component.exports